import React from 'react';
import { useLang } from '@/i18n/LanguageContext';
import { Shield, ShieldCheck, GraduationCap, CheckCircle } from 'lucide-react';
import { motion } from 'framer-motion';

const FullAccreditation = () => {
  const { t, lang } = useLang();

  const title = lang === 'en' ? 'State Licensure' : 'Licencias del Estado';
  const subtitle = lang === 'en' 
    ? 'Official recognition and approval from state regulatory boards.'
    : 'Reconocimiento y aprobación oficial de las juntas reguladoras estatales.';

  return (
    <section id="accreditation" className="py-20 bg-white relative">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <div className="inline-flex items-center justify-center p-3 bg-brand-primary/10 rounded-2xl mb-6">
          <Shield className="w-8 h-8 text-brand-primary" />
        </div>
        
        <h2 className="text-3xl md:text-5xl font-black text-slate-900 mb-6">{title}</h2>
        <p className="text-lg text-slate-600 mb-12 max-w-2xl mx-auto">{subtitle}</p>

        <div className="bg-slate-50 rounded-3xl p-8 md:p-12 shadow-sm border border-slate-200 text-left">
          <div className="flex flex-col md:flex-row gap-8 items-start">
            <div className="w-32 md:w-48 shrink-0 bg-white p-4 rounded-2xl shadow-sm mx-auto md:mx-0">
              <img 
                src="/images/nc-board-seal.png" 
                alt="NC State Board of Dental Examiners Seal" 
                className="w-full h-auto opacity-90"
              />
            </div>
            <div>
              <h3 className="text-2xl font-bold text-slate-900 mb-4">
                {lang === 'en' ? 'State Licensed Institution' : 'Institución Licenciada Estatal'}
              </h3>
              <p className="text-slate-600 mb-6 leading-relaxed">
                {t.footer.accreditation?.text1}
              </p>
              
              <div className="bg-white p-4 rounded-xl border border-slate-200 mb-6">
                <div className="flex items-start gap-3">
                  <ShieldCheck className="w-6 h-6 text-emerald-500 shrink-0 mt-0.5" />
                  <p className="text-sm text-slate-700 font-medium">
                    {t.footer.accreditation?.text2}
                  </p>
                </div>
              </div>

              <div className="space-y-3">
                <div className="flex items-center gap-3">
                  <CheckCircle className="w-5 h-5 text-brand-primary" />
                  <span className="text-slate-700 font-semibold">{lang === 'en' ? 'Approved Curriculum' : 'Plan de Estudios Aprobado'}</span>
                </div>
                <div className="flex items-center gap-3">
                  <CheckCircle className="w-5 h-5 text-brand-primary" />
                  <span className="text-slate-700 font-semibold">{lang === 'en' ? 'State-certified Instructors' : 'Instructores Certificados'}</span>
                </div>
                <div className="flex items-center gap-3">
                  <CheckCircle className="w-5 h-5 text-brand-primary" />
                  <span className="text-slate-700 font-semibold">{lang === 'en' ? 'Meets NC Board Clinical Standards' : 'Cumple los Estándares Clínicos de NC'}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FullAccreditation;
